import React, { Component } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { CSVLink } from "react-csv";
import { GrDocumentCsv } from "react-icons/gr";
import axios from "axios";
import { PaginatedItems } from "../../components/Paginated";
import Loader from "../../components/Loader";
import { PathCustom } from "../../Path/Path";
import { toast } from "react-toastify";
import TableModal from "../../components/TableModal";

export default class POVsPrinted extends Component {
  state = {
    data: [],
    dataFilter: [],
    itemsPerPage: 10,
    loading: false,
    toDate: null,
    fromDate: null,
    refresh: false,
    paginationData: {},
    po_number: "",
    po_vendor: "",
    detailModalOpen: false,
    detailModalData: [],
    detailHeadAndRow: [],
    detailTitle: "",
  };

  getReport = async (pageNumber = 1) => {
    const { po_number, po_vendor } = this.state;


    this.setState({ loading: true });
    try {
      const { data } = await axios.get(
        `${PathCustom}store/po-vs-printed?page=${pageNumber}&PO_Number=${po_number}&PO_Vendor=${po_vendor}`
      );

      if (!data?.data?.data || data.data.data.length === 0) {
        this.setState({
          loading: false,
          data: [],
          dataFilter: [],
          paginationData: {},
        });
        toast.error("No record found");
        return;
      }

      const rows = data.data.data.map((item) => ({
        ...item,
      }));

      this.setState({
        data: rows,
        dataFilter: rows,
        paginationData: data.data,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      toast.error("Something went wrong");
    }
  };

  componentDidMount() {
    this.getReport();
  }

  // formatDate = (date) => {
  //   const d = new Date(date);
  //   let month = "" + (d.getMonth() + 1);
  //   let day = "" + d.getDate();
  //   const year = d.getFullYear();

  //   if (month.length < 2) month = "0" + month;
  //   if (day.length < 2) day = "0" + day;

  //   return [year, month, day].join("-");
  // };

  openDetailModal = async (poNumber, type) => {
    if (!poNumber) {
      toast.error("PO Number not available");
      return;
    }
    this.setState({ loading: true });
    try {
      const { data } = await axios.get(
        `${PathCustom}store/po-vs-printed/items?PO_Number=${poNumber}&type=${type}`
      );

      const rows = data?.data?.data || data?.data || [];

      if (!rows || rows.length === 0) {
        toast.error("No record found");
        this.setState({
          loading: false,
          detailModalOpen: false,
          detailModalData: [],
        });
        return;
      }

      let HeadAndRow = [];
      let title = "";

      if (type === "printed") {
        title = `Printed Items Detail - PO ${poNumber}`;
        HeadAndRow = [
          { header: "Barcode", column: "barcode" },
          { header: "Article Number", column: "articleNumber" },
          { header: "Printer", column: "printerId" },
          { header: "EPC", column: "tagId" },
          { header: "User", column: "userName" },
          { header: "Location", column: "location" },
          { header: "Printed At", column: "createdAt" },
        ];
      } else {
        title = `Remaining Items Detail - PO ${poNumber}`;
        HeadAndRow = [
          { header: "Article Code", column: "Article_Code" },
          { header: "Article Description", column: "Article_Desc" },
          { header: "PO Quantity", column: "PO_Order_Quantity" },
          { header: "Printed Qty", column: "printedQty" },
          { header: "Remaining Qty", column: "remainingQty" },
        ];
      }

      this.setState({
        loading: false,
        detailModalOpen: true,
        detailModalData: rows,
        detailHeadAndRow: HeadAndRow,
        detailTitle: title,
      });
    } catch (error) {
      this.setState({ loading: false });
      toast.error("Something went wrong");
    }
  };

  render() {
    const headers = [
      "PO Number",
      "PO Vendor",
      "PO Quantity",
      "Printed Qty",
      "Remaining Qty",
      "Printers",
    ];

    const colNames = [
      "PO_Number",
      "PO_Vendor",
      "PO_Quantity",
      "printedQty",
      "remainingQty",
      "printers",
    ];

    const headersCSV = [
      { label: "PO Number", key: "PO_Number" },
    { label: "PO Vendor", key: "PO_Vendor" },
      { label: "PO Quantity", key: "PO_Quantity" },
      { label: "Printed Qty", key: "printedQty" },
      { label: "Remaining Qty", key: "remainingQty" },
      { label: "Printers", key: "printers" },
    ];

    const csvData =
      this.state.data?.length > 0
        ? this.state.data.map((item) => ({
            PO_Number: item.PO_Number || "----",
            PO_Vendor: item.PO_Vendor || "",
            PO_Quantity: item.PO_Quantity || 0,
            printedQty: item.printedQty || 0,
            remainingQty: item.remainingQty || 0,
            printers: Array.isArray(item.printers)
              ? item.printers.join(", ")
              : item.printers || "",
          }))
        : [];

    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <div className="dashboard-main">
          <TableModal
            heading="PO vs Printed Detail"
            modalOpen={this.state.detailModalOpen}
            data={this.state.detailModalData}
            closeHandler={() =>
              this.setState({
                detailModalOpen: false,
                detailModalData: [],
                detailHeadAndRow: [],
                detailTitle: "",
              })
            }
            tableTitle={this.state.detailTitle}
            HeadAndRow={this.state.detailHeadAndRow}
          />
          <div
            className="dashboard-top"
            style={{ display: "flex", flexDirection: "column", padding: "10px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p
                className="stock-count"
                style={{ fontSize: "25px", margin: 0 }}
              >
                PO vs Printed (Report)
              </p>
              <a
                href={`${PathCustom}store/po-vs-printed/csv?PO_Number=${this.state.po_number || ""}&PO_Vendor=${this.state.po_vendor || ""}`}
                style={{ display: "flex", alignItems: "center" }}
                title="Download CSV"
              >
                <GrDocumentCsv
                  color="white"
                  fill="white"
                  fontSize={25}
                  style={{ cursor: "pointer" }}
                />
              </a>
            </div>
            <div>
              <h1 style={{ color: "black", fontSize: "15px" }}>
                {new Date().toLocaleString("hi-IN")}
              </h1>
            </div>
          </div>
          <div className="dashboard-bottom">
            <div
              style={{
                display: "flex",
                width: "100%",
                gridColumnGap: "20px",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gridColumnGap: "10px",
                  flexWrap: "wrap",
                }}
              >
  
                <Autocomplete
                  disablePortal
                  id="po-number-filter"
                  size={"small"}
                  freeSolo={true}
                  options={this.state.dataFilter
                    ?.map((item) => item?.PO_Number)
                    .reduce((noDupArr, entry) => {
                      if (noDupArr?.includes(entry)) {
                        return noDupArr;
                      } else {
                        return [...noDupArr, entry];
                      }
                    }, [])
                    .filter(
                      (item) => item !== null && item !== undefined && item !== ""
                    )}
                  onChange={(e, v) =>
                    this.setState({ po_number: v === null ? "" : v })
                  }
                  onInputChange={(e, v) =>
                    this.setState({
                      po_number: v === null || v === undefined ? "" : v,
                    })
                  }
                  sx={{ width: 235 }}
                  renderInput={(params) => (
                    <TextField {...params} label="PO Number" />
                  )}
                />

                <Autocomplete
                  disablePortal
                  id="po-vendor-filter"
                  size={"small"}
                  freeSolo={true}
                  options={this.state.dataFilter
                    ?.map((item) => item?.PO_Vendor)
                    .reduce((noDupArr, entry) => {
                      if (noDupArr?.includes(entry)) {
                        return noDupArr;
                      } else {
                        return [...noDupArr, entry];
                      }
                    }, [])
                    .filter(
                      (item) => item !== null && item !== undefined && item !== ""
                    )}
                  onChange={(e, v) =>
                    this.setState({ po_vendor: v === null ? "" : v })
                  }
                  onInputChange={(e, v) =>
                    this.setState({
                      po_vendor: v === null || v === undefined ? "" : v,
                    })
                  }
                  sx={{ width: 235 }}
                  renderInput={(params) => (
                    <TextField {...params} label="PO Vendor" />
                  )}
                />
              </div>

              <button
                onClick={() => this.getReport()}
                className="button-custom"
              >
                Search
              </button>
            </div>

            <div style={{ paddingTop: "2%" }}>
              <PaginatedItems
                pageCountNew={
                  this.state.paginationData?.next +
                  this.state.paginationData?.previous +
                  1
                }
                getData={(pageNumber) => this.getReport(pageNumber)}
                totalLength={this.state.paginationData?.next}
                refresh={this.state.refresh}
                noAction
                forcePage={this.state.paginationData.previous || 0}
                headers={headers}
                colNames={colNames}
                itemsPerPage={this.state.itemsPerPage}
                data={this.state.data?.map((item) => ({
                  ...item,
                  printedQty: item.printedQty ? (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.openDetailModal(item.PO_Number, "printed");
                      }}
                      style={{ color: "#3D98E6", textDecoration: "underline" }}
                    >
                      {item.printedQty}
                    </a>
                  ) : (
                    item.printedQty
                  ),
                  remainingQty: item.remainingQty ? (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.openDetailModal(item.PO_Number, "remaining");
                      }}
                      style={{ color: "#3D98E6", textDecoration: "underline" }}
                    >
                      {item.remainingQty}
                    </a>
                  ) : (
                    item.remainingQty
                  ),
                  printers: Array.isArray(item.printers)
                    ? item.printers.join(", ")
                    : item.printers || "",
                }))}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


